export var SUGGEST_PROP_DEFAULTS = {
  maxLines: 3,
  maxHeight: 332,
  itemType: 'default'
};
export var SUGGEST_ITEM_FLEX_GAP_SIZE = 12;
export var SUGGEST_MINIMUM_CHARACTERS_FOR_HIGHLIGHT_TO_WORK = 2;